import * as React from "react";
import { Fab, Typography, makeStyles, Box, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Link, ActionItems } from "src/common/components";
import { IconArrowDropDown } from "src/common/icons";
import { IActionPlan } from "src/common/types";
import * as qs from "query-string";

const useStyles = makeStyles((theme: any) => ({
  arrow: {
    fontSize: "1.35rem"
  },
  expandButton: {
    background: "none" as "none",
    boxShadow: "none" as "none"
  },
  noPadding: {
    padding: 0
  },
  accordionSummaryWithBorder: {
    borderBottom: "1px solid #e6e6e6"
  },
  expandedAccordion: {
    width: "100%",
    border: "0",
    boxShadow: "none",
    padding: 0,
    "&:before": {
      height: 0
    }
  }
}));

interface IOwnProps {
  historyPlansByYear: {
    [key: string]: IActionPlan[];
  };
}

const ActionItemsHistoryCard = ({ historyPlansByYear }: IOwnProps) => {
  const {
    t,
    i18n: { language }
  } = useTranslation();
  const classes = useStyles();
  const years = Object.keys(historyPlansByYear);
  return (
    <Box mb={2}>
      {years.map(year => {
        return (
          <Accordion
            key={year}
            style={{
              boxShadow: "0 2px 4px 0 rgb(219 219 219 / 50%)",
              border: "1px solid #e6e6e6",
              borderRadius: "4px"
            }}
          >
            <AccordionSummary
              classes={{
                root: classes.accordionSummaryWithBorder
              }}
              expandIcon={
                <Fab className={classes.expandButton} size="small" disableRipple>
                  <Typography color="primary" className={classes.arrow}>
                    <IconArrowDropDown />
                  </Typography>
                </Fab>
              }
              aria-controls={`panel1a-${year}`}
              id="panel1a-header"
            >
              <Typography display="inline" color="primary" variant="subtitle2">
                {year}
              </Typography>
            </AccordionSummary>
            <AccordionDetails style={{ padding: "0 16px", display: "flex", flexDirection: "column" }}>
              {historyPlansByYear[year].map(historyPlan => {
                return (
                  <Accordion
                    key={historyPlan.id}
                    classes={{
                      root: classes.expandedAccordion,
                      expanded: classes.expandedAccordion
                    }}
                  >
                    <AccordionSummary
                      classes={{
                        root: classes.noPadding
                      }}
                      expandIcon={
                        <Fab className={classes.expandButton} size="small" disableRipple>
                          <Typography color="primary" className={classes.arrow}>
                            <IconArrowDropDown />
                          </Typography>
                        </Fab>
                      }
                      aria-controls={`panel1a-${historyPlan.id}`}
                      id="panel1a-header"
                    >
                      <Typography display="inline" color="primary" variant="subtitle2">
                        <Link
                          to={`/${language}/dashboard/my-feedbacks/talk-sheet/${historyPlan.talkId}?${btoa(
                            qs.stringify(
                              { supported: historyPlan.supportedLanguages },
                              {
                                arrayFormat: "comma"
                              }
                            )
                          )}`}
                        >
                          {historyPlan.cycleName}
                        </Link>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      classes={{
                        root: classes.noPadding
                      }}
                    >
                      <Box display="flex" flexDirection="column" p={2} width="100%">
                        {historyPlan?.actionPlanItems?.length > 0 ? (
                          historyPlan?.actionPlanItems?.map(item => {
                            return <ActionItems key={item.id} item={item} disabled />;
                          })
                        ) : (
                          <Typography>{t("feedback.page.talk-sheet.actionPlan.noLastActionPlan")}</Typography>
                        )}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
};

export default ActionItemsHistoryCard;
